/**
 * Gender and pronouns reference data
 * Supports dropdown selection with custom text option
 */
import { z } from "zod";
// ===== IDENTIFIED GENDER =====
export const IDENTIFIED_GENDER_OPTIONS = [
    { value: "MALE", label: "Male" },
    { value: "FEMALE", label: "Female" },
    { value: "NON_BINARY", label: "Non-binary" },
    { value: "OTHER", label: "Other" },
    { value: "PREFER_NOT_TO_SAY", label: "Prefer not to say" },
];
export const IDENTIFIED_GENDER_VALUES = IDENTIFIED_GENDER_OPTIONS.map((o) => o.value);
export const IdentifiedGenderSchema = z.enum(IDENTIFIED_GENDER_VALUES);
// ===== LEGAL GENDER =====
export const LEGAL_GENDER_OPTIONS = [
    { value: "MALE", label: "Male" },
    { value: "FEMALE", label: "Female" },
    { value: "X", label: "X (Non-binary/Other)" },
    { value: "PREFER_NOT_TO_SAY", label: "Prefer not to say" },
];
export const LEGAL_GENDER_VALUES = LEGAL_GENDER_OPTIONS.map((o) => o.value);
export const LegalGenderSchema = z.enum(LEGAL_GENDER_VALUES);
// ===== PRONOUNS =====
export const PRONOUNS_OPTIONS = [
    { value: "HE_HIM", label: "He/Him" },
    { value: "SHE_HER", label: "She/Her" },
    { value: "THEY_THEM", label: "They/Them" },
    { value: "HE_THEY", label: "He/They" },
    { value: "SHE_THEY", label: "She/They" },
    { value: "CUSTOM", label: "Custom (specify below)" },
    { value: "PREFER_NOT_TO_SAY", label: "Prefer not to say" },
];
export const PRONOUNS_VALUES = PRONOUNS_OPTIONS.map((o) => o.value);
export const PronounsSchema = z.enum(PRONOUNS_VALUES);
